export var ACTIVAR = 'CARTULINA_ACTIVAR';
export var activar = function activar() {
  return {
    type: ACTIVAR
  };
};
export var DESACTIVAR = 'CARTULINA_DESACTIVAR';
export var desactivar = function desactivar() {
  return {
    type: DESACTIVAR
  };
};
export var MOSTRAR = 'CARTULINA_MOSTRAR';
export var mostrar = function mostrar() {
  return {
    type: MOSTRAR
  };
};
export var OCULTAR = 'CARTULINA_OCULTAR';
export var ocultar = function ocultar() {
  return {
    type: OCULTAR
  };
};
export var RESETEAR = 'CARTULINA_RESETEAR';
export var resetear = function resetear() {
  return {
    type: RESETEAR
  };
};
export var CREAR_RECORTE = 'CARTULINA_CREAR_RECORTE';
export var crearRecorte = function crearRecorte(x, y, w, h) {
  return {
    type: CREAR_RECORTE,
    x: x,
    y: y,
    w: w,
    h: h
  };
};
export var RECORTES = 'CARTULINA_RECORTES';
export var recortes = function recortes(_recortes) {
  return {
    type: RECORTES,
    recortes: _recortes
  };
}; // export const MOVER_RECORTE = 'CARTULINA_MOVER_RECORTE'
// export const moverRecorte = (id, x, y, w, h) => ({type: MOVER_RECORTE, id, x, y, w, h })
// export const ELIMINAR_RECORTE = 'CARTULINA_ELIMINAR_RECORTE'
// export const eliminarRecorte = id => ({type: ELIMINAR_RECORTE, id })